import { SvgIcon } from '../../../components'
import * as React from 'react'

function Filter(props, ref) {
  return (
    <SvgIcon
      className='filter-icon'
      viewBox='0 0 16 16'
      {...props}
      ref={ref}
      sx={{
        fontSize: '1.125rem',
        height: '1.125rem',
        width: '1.125rem',
        ...props.sx
      }}
    >
      <path d='M0 3H16V1H0V3Z' fill='currentColor' />
      <path d='M2 7H14V5H2V7Z' fill='currentColor' />
      <path d='M4 11H12V9H4V11Z' fill='currentColor' />
      <path d='M10 15H6V13H10V15Z' fill='currentColor' />
    </SvgIcon>
  )
}

const MemoFilter = React.memo(React.forwardRef(Filter))

export default MemoFilter
